import Office from "../models/Office";

export default class OfficeMapper {
    public map(data: any) : Office {
        const office : Office = new Office();
        office.name = data.Name,
        office.street = data.Street,
        office.houseNumber = data.HouseNumber,
        office.postalCode = data.PostalCode,
        office.city = data.City,
        office.openingHours = data.OpeningHours,
        office.telephone = data.Telephone,
        office.email = data.Email,
        office.latitude = data.Latitude,
        office.longitude = data.Longitude
        
        return office;
    }
}